<!-- <div class="blob_left"> </div>
<div class="blob_right"> </div> -->
<main class="tw-mb-4 tw-font-inter tw-flex tw-flex-col tw-gap-4 tw-bg-gray-50">

    <!-- HERO HEADER -->
    <header
        class="tw-relative tw-py-8 lg:tw-py-20 tw-bg-[url('assets/img/bread3.png')] tw-bg-cover tw-bg-center tw-filter tw-saturate-01">

        <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-rd-600/70 tw-via-rd-700/70 tw-to-rd-900/70"></div>

        <div class="tw-relative container tw-mx-auto tw-text-white">
            <h1 class="tw-text-4xl tw-font-bold tw-m-0">Research Requests</h1>
            <p class="tw-mt-2 tw-text-lg tw-mb-0">Help Researchers Find Resources</p>
        </div>

    </header>


    <!-- BREADCRUMB -->
    <nav aria-label="Breadcrumb">
        <div class="container">
            <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
        </div>
    </nav>


    <!-- SEARCH + FILTERS -->
    <section class="tw-mt-4 lg:tw-mt-8">

        <div class="container tw-text-center tw-mb-8">

            <header>
                <h2 class="tw-text-gray-800 tw-text-2xl">
                    Help Researchers Find Resources
                </h2>

                <p class="tw-text-gray-500 tw-font-normal tw-mb-4">
                    Join our community of researchers and help fulfill academic requests
                </p>
            </header>

            <!-- SEARCH -->
            <app-listings-searchbox [(ngModel)]="searchQuery" [searching]="loading" (search)="onSearchInput()" (clear)="onSearchInput()" placeholder="Search Research Requests..."></app-listings-searchbox>

        </div>


        <!-- RESULTS HEADER -->
        <div class="container tw-mb-4">

            <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">

                <h3 class="tw-m-0 tw-flex tw-items-center tw-gap-1 tw-text-xl">
                    Research Request{{totalCount > 1 ? 's' : ''}}

                    <span class="tw-text-sm tw-bg-rd-500 tw-text-white tw-p-1 tw-px-2 tw-rounded-md">
                        {{ totalCount }}
                    </span>
                </h3>


                <!-- SORT -->
                <div class="tw-flex tw-items-center tw-ms-auto">

                    <app-button
                        size="small"
                        variant="ghost"
                        [severity]="sortOrder === 'desc' ? 'primary' : 'secondary'"
                        icon="fa-regular fa-arrow-down-short-wide"
                        (click)="changeOrder('desc')" title="Descending Order">
                    </app-button>

                    <app-button
                        size="small"
                        variant="ghost"
                        [severity]="sortOrder === 'asc' ? 'primary' : 'secondary'"
                        icon="fa-regular fa-arrow-up-short-wide"
                        (click)="changeOrder('asc')" title="Ascending Order">
                    </app-button>

                </div>


                <!-- FILTER -->
                <app-filters-dropdown class="tw-order-3">

                    <app-form-select
                        label="By Type"
                        [options]="filterOptions.typeOptions"
                        [(ngModel)]="selectedType"
                        (switch)="loadResearchRequests()">
                    </app-form-select>

                </app-filters-dropdown>

            </div>

        </div>

    </section>


    <!-- REQUEST LIST -->
    <section>

        <div class="container">

            <div class="row g-3">

                <!-- LOADING -->
                <ng-container *ngIf="loading">

                    <div class="col-12" *ngFor="let _ of [].constructor(12)">
                        <app-content-loader mode="skeleton" type="request"></app-content-loader>
                    </div>

                </ng-container>


                <!-- ERROR -->
                <ng-container *ngIf="error && !loading">

                    <div class="col-12">
                        <app-content-error
                            [message]="error"
                            (retry)="loadResearchRequests()">
                        </app-content-error>
                    </div>

                </ng-container>


                <!-- RESULTS -->
                <ng-container *ngIf="!loading && !error && researchRequests.length > 0">

                    <article
                        class="col-12"
                        *ngFor="let request of researchRequests">

                        <app-research-card
                            [request]="request"
                            (fulfill)="onUploadClick(request)">
                        </app-research-card>

                    </article>

                </ng-container>


                <!-- EMPTY -->
                <ng-container *ngIf="!loading && !error && researchRequests.length === 0">

                    <app-content-error
                        (clear)="resetSearch()"
                        type="not-found"
                        heading="No Research Requests Results Found"
                        [message]="searchQuery ? `We could not find any research requests for your search: '${searchQuery}'` : 'No research requests are available at the moment.'"
                        icon="fas fa-handshake tw-text-rd-500"
                        [showClear]="searchQuery ? true : false">
                    </app-content-error>

                </ng-container>


                <!-- PAGINATION -->
                <ng-container *ngIf="!loading && !error && researchRequests.length > 0">

                    <div class="col-12">

                        <app-pagination
                            [totalResults]="totalCount"
                            [pageNum]="currentPage"
                            [limit]="itemsPerPage"
                            (pageChange)="goToPage($event)">
                        </app-pagination>

                    </div>

                </ng-container>

            </div>

        </div>

    </section>

</main>

<app-modal [(visible)]="showUploadModal" title="Upload Research Document" size="xl">
    <app-document-uploader [(ngModel)]="uploadData.file" name="file"></app-document-uploader>
    <div rd-modal-footer class="tw-flex tw-gap-2">
        <app-button label="Cancel" severity="secondary" [disabled]="uploadLoading" (click)="closeUploadModal()"
            size="small"></app-button>
        <app-button label="Upload Document" icon="fa-duotone fa-solid fa-up-from-line" [disabled]="!uploadData.file"
            [loading]="uploadLoading" (click)="onUpload()" loadingLabel="Uploading..." size="small"></app-button>
    </div>
</app-modal>

<app-auth-modal [(visible)]="showLoginModal" (loginSuccess)="onLoginSuccess()"
    (closeModal)="closeLoginModal()"></app-auth-modal>